<div class="lmo-frac-fctv-manage">
  <section class="trucking-vendor-list">
    <a
      class="row"
      *ngFor="let fctv of fracClusterTruckingVendors$ | async"
      [routerLink]="['./', fctv.id]"
      routerLinkActive="active-row"
    >
      <div class="cell middle">
        <div class="highlight">
          {{ fctv.truckingVendorName }}
        </div>
      </div>
    </a>
  </section>
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</div>
